import { useEffect, useState, useRef } from 'react';
import { useTranslation } from "react-i18next";
// import { Link, useLocation } from 'react-router-dom';
import { NavLink } from 'react-bootstrap';
// import dayjs from "utils/dayjs";

import { Table, TableBody, TableCell, TableContainer, TableRow, Chip } from '@mui/material';
import { useEnumApi } from 'contexts/EnumApiContext';
import MainCard from 'components/MainCard';
import StatusChart from 'components/inner/chart/StatusChart';
import { getEquipmentCtgrImageNameByCodeOfDashboard, truncateText } from 'data/data';
import { DashboardAreaStackChart } from 'components/inner/chart/DashboardAreaStackChart';
import KakaoMap from 'components/KakaoMap';
import { getDashboardCountByCategoryAndEquipmentStatus, getDashboardCountEquipmentAlertGroupByMonthAndCategory3, getDashboardCountGroupByStatus, getDashboardEquipmentCountGroupByOpStatus, getDashboardZoneCountGroupByRelatedToEquipment } from 'components/axios/dashboardAxios';
import { getEquipmentAlertsByQueryString } from 'components/axios/equipmentAlertsAxios';
import AlertListCard from 'components/inner/mainCard/AlertListCard';
import { getCompaniesGroupCountByType } from 'components/axios/companyAxios';
import { useQuery } from '@tanstack/react-query';

// const DELAY_TIME = 3000;
const DELAY_TIME = Number(process.env.REACT_APP_DELAY_TIME) || 60000;

function DashboardCommonMonitering() {
  const { getEnumValueByEnumName, getEnumValueByEnumNameAndCode, loginInfo } = useEnumApi();
  const { t, i18n } = useTranslation();

  const EquipmentFaultStatusList = getEnumValueByEnumName("EquipmentFaultStatus");

  const { data, isLoading, refetch } = useQuery({
    queryKey: ['dashboard-main', i18n.language],

    queryFn: async () => {
      const alertParam = {
        page: 0,
        size: 12,
        "equipment.iotInstlYn": true,
        "equipment.opStatus": "O",
      };

      let addQueryString = "&sort=status,asc&sort=alertedAt,desc";

      let queryString = Object.entries(alertParam)
        .map(([key, value]) => value && key + '=' + value)
        .filter(v => v)
        .join('&');

      queryString += addQueryString;

      const [
        statusData,
        equipmentAlerts,
        companyTypeCounts,
        zoneCount,
        equipmentCounts,
        equipmentCtgr3Result
      ] = await Promise.all([
        getDashboardCountGroupByStatus({ iotInstlYn: true }),

        getEquipmentAlertsByQueryString("?" + queryString),

        getCompaniesGroupCountByType(),

        getDashboardZoneCountGroupByRelatedToEquipment({ iotInstlYn: true }),

        getDashboardEquipmentCountGroupByOpStatus(),

        getDashboardCountByCategoryAndEquipmentStatus()
          .then((res) =>
            res?.map((data) => ({
              ...data,
              countTT:
                data.countO1N +
                data.countO2I +
                data.countO3A
            }))
          )
      ]);

      // const companyTypeCountTitles =
      //   companyTypeCounts
      //     ?.map((cm) => {
      //       const titleCodes =
      //         cm.groups.filter(
      //           g => g !== loginInfo.company?.type
      //         );

      //       return titleCodes?.map(
      //         t =>
      //           getEnumValueByEnumNameAndCode(
      //             'CompanyType',
      //             t
      //           )?.[0]?.title
      //       );
      //     })
      //     .join(',');

      return {
        statusData,
        equipmentAlerts,
        companyTypeCounts,
        zoneCount,
        equipmentCounts,
        equipmentCtgr3Result,
        // companyTypeCountTitles
      };
    },

    refetchInterval: DELAY_TIME,

    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    // 🔥 탭 안 보여도 멈추지 않음(기본값은 false)
    refetchIntervalInBackground: true,
    
    placeholderData: previousData => previousData,

    staleTime: DELAY_TIME,
  });

  const alertDatas = data?.equipmentAlerts;
  const statusDatas = data?.statusData;
  const companyTypeCounts = data?.companyTypeCounts;
  const zoneCount = data?.zoneCount;
  const equipmentCounts = data?.equipmentCounts;
  const equipmentCtgr3Result = data?.equipmentCtgr3Result;
  // const companyTypeCountTitles = data?.companyTypeCountTitles;


  return (
      <div className="main_container main_container1 cn_main_container">

        <div className='backun_status1'>
          <div className='backun_main_box1'>
            <MainCard content={false} className="cn_status_box">
              <div className='alert_phrase'>
                <div style={{display: "flex", alignItems: "center"}}>
                  <div style={{padding:"5px 10px"}}>
                    <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/dashboard.png`} alt='' /></span>&nbsp;
                    <Chip label={t('message.common.chip.dashboard.alert.list')} color="primary" />
                  </div>
                </div>

                <div className="charts_box2">
                  <AlertListCard equipmentAlerts={alertDatas?._embedded?.equipmentAlerts} target='md' />
                </div>
              </div>
            </MainCard>

            <MainCard content={false} className="cn_status_box">
              <div className='alert_phrase'>
                <div style={{display: "flex", alignItems: "center"}}>
                  <div style={{padding:"5px 10px"}}>
                    <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/dashboard.png`} alt='' /></span>&nbsp;
                    <Chip label={t('message.common.chip.situation.status')} color="primary" />
                  </div>
                </div>

                <div className="charts_box2">
                  {(EquipmentFaultStatusList && statusDatas) && <StatusChart EquipmentFaultStatusList={EquipmentFaultStatusList} statusDatas={statusDatas} />}
                </div>
              </div>
            </MainCard>
          </div>

          <div className='backun_main_box2'>
            <div>
              <div className='backun_main_inbox2'>
                <MainCard content={false} className="cn_status_box">
                  <div className='alert_phrase'>
                    <div style={{display: "flex", alignItems: "center"}}>
                      <div style={{padding:"0 10px"}}>
                        <Chip label={t('message.common.chip.company.count')} color="primary" />
                      </div>
                    </div>

                    <div className="charts_box3">
                      {companyTypeCounts?.reduce((acc, cm) => {
                        if (!cm.groups.includes(loginInfo.company?.type)) {
                          return acc + cm.count;
                        }
                        return acc;
                      }, 0) ?? 0}
                    </div>
                  </div>
                </MainCard>

                <MainCard content={false} className="cn_status_box">
                  <div className='alert_phrase'>
                    <div style={{display: "flex", alignItems: "center"}}>
                      <div style={{padding:"0 10px"}}>
                        <Chip label={t('message.common.chip.zone.count')} color="primary" />
                      </div>
                    </div>

                    <div className="charts_box3">
                      {zoneCount?.cnt ?? 0}
                    </div>
                  </div>
                </MainCard>

                <MainCard content={false} className="cn_status_box">
                  <div className='alert_phrase'>
                    <div style={{display: "flex", alignItems: "center"}}>
                      <div style={{padding:"0 10px"}}>
                        <Chip label={t('message.common.chip.register.equipment.count')} color="primary" />
                      </div>
                    </div>

                    <div className="charts_box3">
                      {equipmentCounts?.find((cm)=> cm.groups.includes('O'))?.count ?? 0}
                    </div>
                  </div>
                </MainCard>
              </div>

              <div className='alert_phrase kakaomap'>
                <KakaoMap />
                {/* <NavLink href={'/equipment'}><img src={`${process.env.PUBLIC_URL}/img/dashboard/map.png`} alt='' /></NavLink> */}
                {/* {mapZones && <KakaoMap mapZones={mapZones} />} */}
                {/* {mapZones?.positions?.length > 0 && (
                )} */}
                {/* <NaverMap /> */}
              </div>
            </div>
          </div>
        </div>

        <div className='backun_status2'>
          <MainCard className='backun_main_box3' content={false} style={{position:"relative", boxSizing: "border-box"}}>
            <div className='alert_phrase'>
              <div style={{display: "flex", alignItems: "center"}}>
                <div style={{padding:"5px 10px"}}>
                  <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/dashboard.png`} alt='' /></span>&nbsp;
                  <Chip label={t('message.common.chip.level3.status')} color="primary" />
                </div>
              </div>
              
              <div className="small_motion_box" style={{padding:"10px"}}>
                {equipmentCtgr3Result?.map((lvl3, l)=> {
                  return (
                <div key={l} className="small_motion_group">
                  <div className="small_motion1">
                    <div>
                      <div className='bgwhite' style={{textAlign:"center"}}>
                        <div className='backun_main_box3_tit'>* {lvl3.category3Name}</div>
                        <NavLink href={`/equipment?searchlevel1=${lvl3.category1Id}&searchlevel2=${lvl3.category2Id || ''}&searchlevel3=${lvl3.category3Id}`}>
                        <div className='main_motion'><img src={`${process.env.PUBLIC_URL}/img/small_motion/${getEquipmentCtgrImageNameByCodeOfDashboard(lvl3.category3Code)}`} alt='' /></div>
                        {/* <div className='main_motion'><img src={`${process.env.PUBLIC_URL}/img/small_motion/${getEquipmentCtgrImageNameByCodeOfDashboard(lvl3.category1Code)}`} alt='' /></div> */}
                        </NavLink>
                      </div>

                      <TableContainer className="table_part" style={{padding:"5px"}}>
                        <Table aria-label="simple table">
                          <TableBody>
                            <TableRow>
                              <TableCell>{t('message.common.total')}</TableCell>
                              <TableCell>{lvl3.countTT}</TableCell>
                              <TableCell>{t('message.common.title.alarm')}</TableCell>
                              <TableCell className='font_orange'>{lvl3.countO3A}</TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell>{t('message.common.normal')}</TableCell>
                              <TableCell className='font_green'>{lvl3.countO1N}</TableCell>
                              <TableCell>{t('message.common.interest')}</TableCell>
                              <TableCell className='font_yellow'>{lvl3.countO2I}</TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer> 
                    </div>
                  </div>
                </div>
                  )
                })
                }
              </div>
            </div>
          </MainCard>

          <MainCard className='backun_main_box4' content={false} style={{position:"relative", boxSizing: "border-box"}}>
            <div className='alert_phrase'>
              <div style={{display: "flex", alignItems: "center"}}>
                <div style={{padding:"5px 10px"}}>
                  <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/dashboard.png`} alt='' /></span>&nbsp;
                  <Chip label={t('message.common.chip.level3.diagnosis.status')} color="primary" />
                </div>
              </div>
              
              <div className="charts_box2">
                <DashboardAreaStackChart />
              </div>
            </div>
          </MainCard>
        </div>
      </div>
    )
  // }
}

export default DashboardCommonMonitering;
